"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactRedux = require("react-redux");
var _TermsAndConditions = _interopRequireDefault(require("./TermsAndConditions"));
var _termsModule = require("./termsModule");
var _listingModule = require("../listing/listingModule");
var _AnalyticsModule = require("../analytics/modules/AnalyticsModule");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function mapStateToProps(state) {
  return {
    terms: state.terms,
    sharedInfo: state.sharedInfo,
    userId: state.userPrefs.userId,
    listing: state.listing,
    companyUUID: state.userPrefs.companyUUID
  };
}
var mapDispatchToProps = {
  toggleModal: _termsModule.toggleTaCModal,
  toggleNeedAnAccountClicked: _listingModule.toggleNeedAnAccountClicked,
  launchModal: _termsModule.launchTaCModal,
  updateTermsStatus: _termsModule.updateCurrentlyAccepted,
  connect: _listingModule.connectListing,
  trackButtonClick: _AnalyticsModule.buttonClickDispatch,
  trackLinkClick: _AnalyticsModule.linkClickDispatch
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_TermsAndConditions.default);